import { SavedSearchDto } from '../models/SavedSearch';

export const getSortedSavedSearches = (savedSearches: SavedSearchDto[]): SavedSearchDto[] =>
  sortByDate(sortFilters(savedSearches));

const sortByDate = (savedSearches: SavedSearchDto[]) =>
  [...savedSearches].sort((a, b) => b.createdAt.localeCompare(a.createdAt));

const sortFilters = (savedSearches: SavedSearchDto[]) =>
  savedSearches.map((savedSearch) => ({
    ...savedSearch,
    filters: savedSearch.filters
      ?.sort((a, b) => a.filterType.localeCompare(b.filterType))
      .map((filter) => ({ ...filter, tags: filter.tags.sort() })),
  }));
